// src/components/common/taskbox/RecentActivitiesWidget.js
import React from 'react';
import { Clock } from 'lucide-react';

const RecentActivitiesWidget = ({ activities = [], theme }) => {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diff = now - date;
        const minutes = Math.floor(diff / (1000 * 60));
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));

        if (minutes < 1) return 'Just now';
        if (minutes < 60) return `${minutes}m ago`;
        if (hours < 24) return `${hours}h ago`;
        if (days < 7) return `${days}d ago`;

        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'Asia/Kolkata' });
    };

    return (
        <div className={`rounded-xl p-6 border ${
            theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
        }`}>
            <div className="flex items-center justify-between mb-4">
                <h3 className={`text-lg font-semibold ${
                    theme === 'dark' ? 'text-white' : 'text-gray-900'
                }`}>
                    Recent Activities
                </h3>
                <span className={`text-sm px-3 py-1 rounded-full ${
                    theme === 'dark' ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-700'
                }`}>
                    {activities.length}
                </span>
            </div>

            <div className="space-y-3 max-h-96 overflow-y-auto">
                {activities.length === 0 ? (
                    <div className="text-center py-8">
                        <Clock className={`w-12 h-12 mx-auto mb-2 ${
                            theme === 'dark' ? 'text-gray-600' : 'text-gray-400'
                        }`} />
                        <p className={`text-sm ${
                            theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                        }`}>
                            No recent activities
                        </p>
                    </div>
                ) : (
                    activities.map((activity, index) => (
                        <div
                            key={activity.id || index}
                            className={`p-3 rounded-lg border ${
                                theme === 'dark'
                                    ? 'bg-gray-700/50 border-gray-600'
                                    : 'bg-gray-50 border-gray-200'
                            }`}
                        >
                            <div className="flex items-start justify-between gap-2">
                                <h4 className={`text-sm font-medium ${
                                    theme === 'dark' ? 'text-white' : 'text-gray-900'
                                }`}>
                                    {activity.title}
                                </h4>
                                <span className={`text-xs ${
                                    theme === 'dark' ? 'text-gray-500' : 'text-gray-500'
                                }`}>
                                    {formatDate(activity.activity_date)}
                                </span>
                            </div>
                            {activity.description && (
                                <p className={`text-xs mt-1 ${
                                    theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                                }`}>
                                    {activity.description}
                                </p>
                            )}
                            {activity.location && (
                                <p className={`text-xs mt-1 ${
                                    theme === 'dark' ? 'text-gray-500' : 'text-gray-500'
                                }`}>
                                    📍 {activity.location}
                                </p>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default RecentActivitiesWidget;
